import React from 'react';

import Auth from 'service/auth';
import { Link } from 'react-router-dom';

import Protected from 'component/Protected';

class MenuNavigator extends React.Component
{

  render()
  {
    if (!Auth.User) { return <nav className="MenuNavigator"></nav>; }

    return (
      <nav className="MenuNavigator">
        <ul>
          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY','VIEWER_NIGHT']}>
            <li>
              <div>基本資料</div>
              <ul className="drop-down">
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
                  <Link to="/info/staff">員工資料</Link>
                </Protected>
                <Link to="/info/owners">車主及車輛</Link>
                <Link to="/info/service-locations">屋苑及車場</Link>
                <Link to="/info/service-plans">服務計劃</Link>
                <Link to="/info/unit-services">服務及商品</Link>
              </ul>
            </li>
          </Protected>

          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY','VIEWER_NIGHT']}>
            <li>
              <div>日常操作</div>
              <ul className="drop-down">
                <Link to="/op/services">車輛服務</Link>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY']}>
                  <Link to="/op/bills/overdue">賬單及催款單</Link>
                </Protected>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU']}>
                  <Link to="/op/bills/payment">收據</Link>
                </Protected>
                <Link to="/op/orders">訂單</Link>
                <Link to="/op/messages">訊息</Link>
              </ul>
            </li>
          </Protected>
          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
            <li>
              <div>日程</div>
              <ul className="drop-down">
                <Link to="/op/staff/schedule">員工班期</Link>
                <Link to="/op/location/schedule">車場日程</Link>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_NIGHT']}>
                  <Link to="/op/staff-leave">請假表</Link>
                </Protected>
              </ul>
            </li>
          </Protected>
          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_DAY','VIEWER_NIGHT']}>
            <li>
              <div>紀錄</div>
              <ul className="drop-down">
                <Link to="/rec/monthly-services">月費服務紀錄</Link>
                <Link to="/rec/suspended-services">終止服務紀錄</Link>
                <Link to="/rec/cheque-records">收款紀錄</Link>
                <Link to="/rec/einvoicing-audits">電子賬單及收據紀錄</Link>
              </ul>
            </li>
          </Protected>

          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
            <li>
              <div>報表</div>
              <ul className="drop-down">
                <Protected allow={['ADMIN','VIEWER_SU']}>
                  <Link to="/reports/profit">營業額</Link>
                </Protected>
                <Protected allow={['ADMIN','VIEWER_SU']}>
                  <Link to="/reports/優悠家居">優悠家居</Link>
                </Protected>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
                  <Link to="/report/service-by-location">屋苑服務統計</Link>
                </Protected>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
                  <Link to="/report/staff-salary">工資結算</Link>
                </Protected>
              </ul>
            </li>
          </Protected>

          <Protected allow={['ADMIN','OPERATOR']}>
            <li>
              <div>其他管理</div>
              <ul className="drop-down">
                <Link to="/admin/switch-worker">工人交接</Link>
                <Link to="/admin/merge-customer">合拼客戶</Link>
                <Link to="/admin/split-customer">分拆客戶</Link>
                { /* */ }
              </ul>
            </li>
          </Protected>

        </ul>
      </nav>
    );
  }

}



export default MenuNavigator;